/*
  Membership plan groups (sections/custom-membership.liquid): tab buttons show
  one group of cards at a time. Without JS every card is shown.
*/
(() => {
  if (customElements.get('membership-plans')) return;

  class MembershipPlans extends HTMLElement {
    connectedCallback() {
      this.tabs = this.querySelector('.membership__tabs');
      if (!this.tabs) return;
      this.buttons = [...this.tabs.querySelectorAll('.membership__tab')];
      this.cards = [...this.querySelectorAll('.membership-card[data-group]')];
      if (this.buttons.length < 2) return;

      this.tabs.hidden = false;
      this.buttons.forEach((button) => button.addEventListener('click', () => this.select(button.dataset.group)));
      const preferred = this.dataset.activeGroup;
      this.select(this.buttons.some((b) => b.dataset.group === preferred) ? preferred : this.buttons[0].dataset.group);
    }

    select(group) {
      this.buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.group === group)));
      this.cards.forEach((card) => (card.hidden = card.dataset.group !== group));
      this.style.setProperty('--visible', this.cards.filter((card) => !card.hidden).length);
    }
  }

  customElements.define('membership-plans', MembershipPlans);
})();
